var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.17.55.1-Setup-/-Company-/-Create-new-project-/-Step-3-/-Add-question---question-3-expand",
    transform: "translate(-1213.000000, -596.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-new-project",
    transform: "translate(672.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right",
    transform: "translate(218.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-copy-3",
    transform: "translate(0.000000, 224.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(32.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(279.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(12.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5625,3.24999996 C14.4254449,3.24999996 15.125,3.94955504 15.125,4.81249996 L15.125,5.74999996 L18.875,5.74999996 C19.220178,5.74999996 19.5,6.029822 19.5,6.37499997 C19.5,6.72017794 19.220178,6.99999997 18.875,6.99999997 L18.2109375,6.99999997 L17.46875,18.9140625 C17.4023438,19.9773438 16.6144531,20.75 15.59375,20.75 L8.40624998,20.75 C7.39062498,20.75 6.58671872,19.9597657 6.53124997,18.9109375 L5.78906247,6.99999997 L5.12499997,6.99999997 C4.779822,6.99999997 4.49999996,6.72017794 4.49999996,6.37499997 C4.49999996,6.029822 4.779822,5.74999996 5.12499997,5.74999996 L8.87499998,5.74999996 L8.87499998,4.81249996 C8.87499998,3.94955504 9.57455507,3.24999996 10.4375,3.24999996 Z M9.16523436,8.24999998 C8.82005639,8.26229695 8.55020302,8.55208764 8.56249998,8.89726561 L8.87499998,17.6472657 C8.88699366,17.9837184 9.16333358,18.2502137 9.49999999,18.2500002 L9.52226561,18.2500002 C9.6880619,18.2441989 9.8447496,18.1727191 9.95780622,18.0513096 C10.0708628,17.9299002 10.1310116,17.7685232 10.125,17.6027344 L9.81249999,8.85273436 C9.80020302,8.50755639 9.51041233,8.23770302 9.16523436,8.24999998 Z M12,8.24999998 C11.654822,8.24999998 11.375,8.52982201 11.375,8.87499998 L11.375,17.625 C11.375,17.970178 11.654822,18.25 12,18.25 C12.345178,18.25 12.625,17.970178 12.625,17.625 L12.625,8.87499998 C12.625,8.52982201 12.345178,8.24999998 12,8.24999998 Z M15.1442826,8.3448669 C14.9548843,8.22633239 14.7166357,8.21784478 14.5192826,8.32260128 C14.3219296,8.42735777 14.1954547,8.62944336 14.1875,8.85273436 L13.875,17.6027344 C13.8689872,17.7684579 13.9290827,17.9297772 14.0420556,18.0511755 C14.1550285,18.1725738 14.3116163,18.2440976 14.4773438,18.2500002 L14.5,18.2500002 C14.8366664,18.2502137 15.1130063,17.9837184 15.125,17.6472657 L15.4375,8.89726561 C15.4454548,8.67397461 15.3336809,8.46340141 15.1442826,8.3448669 Z",
    id: "Combined-Shape",
    fill: "#DB3D49",
    mask: "url(#mask-2)"
  })))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.fb3c58ac.svg";
export { ForwardRef as ReactComponent };